import { commonComponents as cc } from "@/components/common";
import { ui } from "@patient-watch/ui";
import { Link, useNavigate } from "@tanstack/react-router";
import { Expand } from "lucide-react";
import { useSelectTeamMembers } from "../api/selectTeamMembers";
import { useSelectSecretaryOrganisations } from "../api/selectSecretaryOrganisations";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { formComponents as fc } from "@/features/i18n/formComponents";
import { useAuth } from "@/utils/auth";
import TeamTable, { TEAM_PREVIEW_LIMIT } from "./TeamTable";

const TeamPreviewCard = () => {
    const copy = useProfileCopy();
    const navigate = useNavigate();
    const auth = useAuth();
    const { data, isLoading } = useSelectTeamMembers();
    const { data: secretaryAssignments = [] } = useSelectSecretaryOrganisations(auth.id);

    const members = data?.members ?? [];
    const currentUserOrganisations = data?.currentUserOrganisations ?? [];
    const remainingCount = Math.max(0, members.length - TEAM_PREVIEW_LIMIT);

    if (isLoading) {
        return (
            <cc.Group title={copy.myTeam}>
                <ui.Skeleton className="w-full h-24" />
            </cc.Group>
        );
    }

    return (
        <cc.Group
            title={copy.myTeam}
            headerAction={
                <div data-testid="team-invite-user">
                    <fc.AddButton
                        buttonType="button"
                        size="default"
                        className="w-auto"
                        onClick={() => navigate({ to: "/team/invite" })}
                    />
                </div>
            }
        >
            {members.length === 0 ? (
                <div className="py-4 text-muted-foreground text-center">
                    <p className="text-sm">{copy.noTeamMembersYet}</p>
                    <p className="text-2xs">{copy.inviteColleaguesToBuildTeam}</p>
                </div>
            ) : (
                <>
                    <TeamTable
                        variant="preview"
                        members={members}
                        currentUserOrganisations={currentUserOrganisations}
                        secretaryAssignments={secretaryAssignments}
                    />
                    {remainingCount > 0 && (
                        <p className="pt-2 text-2xs text-muted-foreground text-center">
                            {copy.moreTeamMembers(remainingCount)}
                        </p>
                    )}
                </>
            )}

            <ui.Button variant="outline" className="mt-4 w-full" asChild>
                <Link to="/team" data-testid="team-manage">
                    <Expand size={16} className="mr-2" />
                    {copy.manageTeam}
                </Link>
            </ui.Button>
        </cc.Group>
    );
};

export default TeamPreviewCard;
